<template>
    <div class="cms-view__element" :class="contentTypeClass">
        <component
            v-if="
                componentMapping[element.type] &&
                    componentMapping[element.type][element.appearance.layout]
            "
            :is="componentMapping[element.type][element.appearance.layout]"
            :key="'cms_content_element_' + element.id"
            :content-data="element"
        >
        </component>
        <div v-else class="container">
            <div class="message is-warning cms-view__element--fallback">
                <div class="message-header is-size-4">
                    Dieses Inhaltselement kann leider nicht dargestellt
                    werden...
                </div>
                <div class="message-body">
                    <template v-if="!componentMapping[element.type]">
                        <p class="is-size-4">
                            Inhaltselemente vom Typ
                            <strong>{{ element.type }}</strong> sind zur Zeit
                            nicht implementiert. Bitte warte, bis das Element in
                            einem Update nachgeliefert wird oder wähle ein
                            anderes Element.
                        </p>
                        <br />
                        <p class="is-size-4">Verfügbare Inhaltstypen:</p>
                        <br />
                        <ul class="ml-4 is-size-5" type="1">
                            <li>Überschrift</li>
                            <li>Text</li>
                            <li>Text und Bilder</li>
                        </ul>
                    </template>
                    <template
                        v-else-if="
                            !componentMapping[element.type][
                                element.appearance.layout
                            ]
                        "
                    >
                        <p class="is-size-4">
                            Inhaltselemente vom Typ
                            <strong>{{ element.type }}</strong> sind im
                            gewählten Layout nicht implementiert.
                        </p>
                        <br />
                        <p class="is-size-4">
                            Bitte warte, bis das gewählte Layout in einem Update
                            nachgeliefert wird oder wähle das Standard Layout.
                        </p>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ContentPreview from './ContentPreview';
import RichText from './RichText';
import ProductBoxElement from './ProductBoxElement';
import ProductBoxElementQuarter from './ProductBoxElement';
import StoryNavigation from '../layout/StoryNavigation';
import HeroBanner from './HeroBanner';
import Banner from './Banner';
import CallToAction from './CallToAction';
import SplitSection from './SplitSection';
import PictureAndText from './PictureAndText';
import { componentMapping } from '../../store/constants/component-mapping';
import Divider from './Divider';
import HTMLView from './HTMLView';

export default {
    name: 'CMSViewComponent',
    data() {
        return {
            componentMapping: componentMapping,
        };
    },
    components: {
        ContentPreview,
        RichText,
        ProductBoxElement,
        ProductBoxElementQuarter,
        StoryNavigation,
        HeroBanner,
        CallToAction,
        SplitSection,
        Banner,
        PictureAndText,
        Divider,
        HTMLView,
    },
    props: {
        element: {
            type: Object,
            required: true,
        },
    },
    computed: {
        contentTypeClass() {
            if (
                componentMapping[this.element.type] &&
                componentMapping[this.element.type][
                    this.element.appearance.layout
                ] === 'product-box-element'
            ) {
                return 'product-box';
            } else if (
                componentMapping[this.element.type] &&
                componentMapping[this.element.type][
                    this.element.appearance.layout
                ] === 'product-box-element-quarter'
            ) {
                return 'product-box product-box--quarter';
            } else if (
                componentMapping[this.element.type] &&
                componentMapping[this.element.type][
                    this.element.appearance.layout
                ] === 'picture-and-text'
            ) {
                return 'picture-and-text';
            } else if (
                componentMapping[this.element.type] &&
                componentMapping[this.element.type][
                    this.element.appearance.layout
                ] === 'content-preview'
            ) {
                return 'content-preview';
            } else if (
                componentMapping[this.element.type] &&
                componentMapping[this.element.type][
                    this.element.appearance.layout
                ] === 'story-navigation'
            ) {
                return 'story-navigation__anchor';
            } else if (
                componentMapping[this.element.type] &&
                componentMapping[this.element.type][
                    this.element.appearance.layout
                ] === 'hero-banner'
            ) {
                return 'hero-banner';
            } else if (
                componentMapping[this.element.type] &&
                componentMapping[this.element.type][
                    this.element.appearance.layout
                ] === 'h-t-m-l-view'
            ) {
                return 'html-view';
            }
            return null;
        },
    },
};
</script>

<style></style>
